<template>
    <nav class="panel">
        <p class="panel-heading">
            General information
        </p>
        <div class="panel-block">
            <table class="table table-mobile-card" style=" width: 100%">
                <tbody>
                    <tr>
                        <td style="width: 200px;"><b>Status</b></td>
                        <td>{{getOrderStateByCode(orderInfo.state)}}</td>
                    </tr>
                    <tr>
                        <td><b>Email</b></td>
                        <td>{{orderInfo.email}}</td>
                    </tr>
                    <tr>
                        <td><b>Create date</b></td>
                        <td>{{ dateFormat(orderInfo.order_date)}}</td>
                    </tr>
                    <tr>
                        <td><b>Number of items</b></td>
                        <td>{{orderInfo.items.length}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </nav>
</template>

<script>
import DateMixin from '@/mixins/DateMixin'

export default {
  props: {
    orderInfo: Object
  },
  mixins: [DateMixin],
  data () {
    return {
    }
  },
  methods: {
    getOrderStateByCode: function (code) {
      let orderStatuses = {
        1: 'Order is new and not processed',
        5: 'Order is being verified',
        6: 'Order has been verified',
        7: 'Order verification error',
        10: 'Order files are being downloaded',
        11: 'Order files download error',
        15: 'Order files has been downloaded',
        30: 'Order is being rendered',
        31: 'Order render error',
        32: 'Order has been rendered',
        33: 'Order file is being distributed',
        34: 'Order file has been distributed',
        35: 'Order file distribute error',
        37: 'Order file is being created',
        38: 'Order file has been created',
        39: 'Order file create error',
        40: 'Order files are being uploaded',
        41: 'Order files upload error',
        42: 'Order waiting for upload accept',
        45: 'Order files has been uploaded',
        100: 'Order complete - All items in the order has been shipped or delivered',
        500: 'Order has been canceled',
        501: 'Sandbox order processing complete'
      }

      return orderStatuses[code]
    }
  }
}
</script>
